import { memo } from 'react';
import * as Carousel from 'root/src/client/v2/common/components/Carousel/Carousel';
import { twMerge } from 'tailwind-merge';
export const RewardsCarousel = memo((props) => {
    const { rewards, renderReward, plugins = [], containerClassName, slideClassName, loop = true, dragFree = true, } = props;
    return (<Carousel.Root loop={loop} dragFree={dragFree} plugins={plugins} className="w-full">
			<Carousel.Container className={twMerge('-ml-4 flex pt-2', containerClassName)}>
				{rewards.map(reward => (<div key={reward.id} className={twMerge('pl-4 w-full relative', slideClassName)}>
						{renderReward(reward)}
					</div>))}
			</Carousel.Container>
		</Carousel.Root>);
});
